<script setup>
// Playground (phase 4.6, D-P4): its own page. The header says "Playground" and holds "Restart"; the woot's sentence
// sits above the test conversation (AssistantPlayground, on the kit's Preview plant), which fills the page's height
// and scrolls by itself.
// Fase 7 (tela 06, spec §4.7): o seletor "Testando como" (lead novo / contato existente) acima da conversa e o
// painel "Detalhes da execução" ao lado, alimentado pelo run_details de cada resposta.
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'dashboard/composables/store';
import { Reset16 } from '@carbon/icons-vue';
import { Button } from 'dashboard/components-next/polaris/ui/button';
import PageLayout from 'dashboard/components-next/polaris/PageLayout.vue';
import AssistantPlayground from 'dashboard/components-next/polaris/assistant/AssistantPlayground.vue';
import PlaygroundPersonaPicker from 'dashboard/components-next/polaris/assistant/PlaygroundPersonaPicker.vue';
import PlaygroundRunDetails from 'dashboard/components-next/polaris/assistant/PlaygroundRunDetails.vue';

const route = useRoute();
const store = useStore();
const assistantId = computed(() => Number(route.params.assistantId));
const assistantName = computed(
  () => store.getters['polarisAssistants/getRecord'](assistantId.value)?.name
);
const playground = ref(null);

const contactId = ref(null);
const runDetails = ref(null);

const onPersonaSelect = id => {
  contactId.value = id;
  // Trocar de persona no meio mistura contextos: a conversa de teste recomeça.
  playground.value?.reset();
  runDetails.value = null;
};
</script>

<template>
  <PageLayout
    :header-title="$t('POLARIS.PLAYGROUND.HEADER')"
    :show-pagination-footer="false"
    :show-know-more="false"
    fill
  >
    <template #headerActions>
      <Button variant="outline" size="sm" @click="playground?.reset()">
        <Reset16 aria-hidden="true" />
        {{ $t('POLARIS.PAGES.PLAYGROUND.RESTART') }}
      </Button>
    </template>
    <template #body>
      <div class="flex min-h-0 flex-1 flex-col gap-3">
        <p
          class="max-w-prose shrink-0 type-polaris-body text-polaris-muted-foreground"
        >
          {{ $t('POLARIS.PLAYGROUND.DESCRIPTION') }}
        </p>
        <PlaygroundPersonaPicker @select="onPersonaSelect" />
        <div class="flex min-h-0 flex-1 gap-4">
          <AssistantPlayground
            ref="playground"
            :assistant-id="assistantId"
            :assistant-name="assistantName"
            :contact-id="contactId"
            class="min-h-0 flex-1"
            @run-details="runDetails = $event"
          />
          <PlaygroundRunDetails :run-details="runDetails" />
        </div>
      </div>
    </template>
  </PageLayout>
</template>
